export default __webpack_public_path__ + "static/media/base-station.f39eec94.webp";